// Order and cart summary labels shared by checkout, the receipt, and the cart sidebar.
export const orderSummaryContent = {
  orderSummaryHeading: 'Order Summary',
  orderForTemplate: 'Order for ##SubjectName##',
  yourItemsHeading: 'Your Items',
  extrasHeading: 'Extras',
  quantityLabelTemplate: 'Qty: ##Quantity##',

  // Totals
  subtotalLabel: 'Subtotal',
  subtotalColonLabel: 'Subtotal:',
  studentSubtotalLabel: 'Student Subtotal',
  discountLabel: 'Discount',
  salesTaxLabel: 'Sales Tax',
  shippingHandlingLabel: 'Shipping & Handling',
  adjustmentLabel: 'Adjustment',
  totalLabel: 'Total',
  freeLabel: 'FREE',
  amountSavedTemplate: 'You saved $##Amount##',
  shippingAndTaxesAtCheckoutNote: 'Shipping & taxes calculated at checkout'
}
